/** The pause, said under the button it disabled. Nothing when not paused. */
export function CheckoutPausedNote({ message, className }: { message: string | null; className?: string }) {
  if (!message) return null;
  return (
    <p role="status" className={className ?? 'mt-2 text-sm'} style={{ color: 'var(--storefront-muted)' }}>
      {message}
    </p>
  );
}
